import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";

export default function AdSlot({ placement = "sidebar" }) {
  const { data: ads = [] } = useQuery({
    queryKey: ["ads", placement],
    queryFn: async () => (await api.get(`/ads?placement=${placement}`)).data,
  });

  if (!ads.length) return null;

  if (placement === "banner") {
    const ad = ads[0];
    return (
      <a href={ad.link_url} className="block relative overflow-hidden border border-border group" data-testid="ad-banner">
        <img src={ad.image_url} alt={ad.title} className="w-full h-40 object-cover transition-transform duration-300 group-hover:scale-105" />
        <div className="absolute inset-0 bg-[#0A0A0A]/50 flex items-center px-8">
          <div>
            <span className="label-tech text-primary bg-white px-2 py-0.5">Sponsored</span>
            <p className="text-white font-display text-2xl font-bold mt-2">{ad.title}</p>
          </div>
        </div>
      </a>
    );
  }

  return (
    <div className="space-y-4" data-testid="ad-sidebar">
      <span className="label-tech text-muted-foreground">Advertisement</span>
      {ads.map((ad) => (
        <a key={ad.id} href={ad.link_url} className="block tech-card overflow-hidden" data-testid={`ad-${ad.id}`}>
          <img src={ad.image_url} alt={ad.title} className="w-full h-32 object-cover" />
          <div className="p-4">
            <p className="font-semibold text-sm">{ad.title}</p>
          </div>
        </a>
      ))}
    </div>
  );
}
